import axios from 'axios';

const getBannerApi = () => {
	return axios.get('https://backend.planmyleisure.com/blog/get-Banners');
};

export default getBannerApi;
